<template>
  <div class="box">
    <el-form
      :model="rule"
      :rules="rules"
      ref="rule"
      label-width="120px"
      class="demo-ruleForm"
      :validate-on-rule-change="false"
    >
      <div class="title">设备信息</div>

      <el-form-item>
        <el-radio-group v-model="rule.institution" @change="onSwitch">
          <el-radio label="0">出库到机构</el-radio>
          <el-radio label="1">出库到个人</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="rule.institution === '0'">
        <el-form-item label="机构名称" prop="ins_id">
          <el-select v-model="rule.ins_id">
            <el-option value="" label="请选择"></el-option>
            <el-option
              v-for="x in selectList"
              :key="x.id"
              :value="x.id"
              :label="x.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="rule.institution === '1'">
        <el-form-item label="手机号码" prop="user_id">
          <Individual-customers
            :showOnly="true"
            :handleUserChange="handleUserChange"
          ></Individual-customers>
        </el-form-item>
      </template>
      <el-form-item>
        <el-radio-group v-model="rule.device" @change="onSwitchDevice">
          <el-radio label="0">单台设备</el-radio>
          <el-radio label="1">多台设备</el-radio>
        </el-radio-group>
      </el-form-item>
      <template v-if="rule.device === '0'">
        <el-form-item label="设备号" prop="dev_id">
          <el-input
            placeholder="请输入设备号"
            v-model="rule.dev_id"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="关联场景" prop="inJoin">
          <el-radio-group v-model="rule.inJoin">
            <el-radio label="1">仓库</el-radio>
            <el-radio label="2">门店</el-radio>
            <el-radio label="3">运输</el-radio>
          </el-radio-group>
        </el-form-item>
      </template>
      <template v-if="rule.device === '1'">
        <el-form-item label="设备列表" prop="file">
          <input type="file" name="file" @change="getFile($event)" />
          <el-link target="_blank" :href="url" :underline="false">
            <el-button type="text">下载设备文件模版</el-button>
          </el-link>
        </el-form-item>
      </template>
      <div class="title" style="margin-bottom: 12px">服务信息</div>
      <el-form-item label="服务状态" prop="use_status">
        <el-select v-model="rule.use_status">
          <el-option value="official" label="正式使用"></el-option>
          <el-option value="probation" label="试用"></el-option>
          <el-option value="test" label="测试"></el-option>
        </el-select>
      </el-form-item>
      <template v-if="rule.use_status === 'official'">
        <el-form-item label="CRM订单号" prop="crm">
          <el-input v-model="rule.crm"></el-input>
        </el-form-item>
        <el-form-item label="是否全部付款" @change="onPay">
          <el-radio-group v-model="rule.payState">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否 </el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="rule.payState === '0'">
          <el-form-item label="预期付款时间" prop="payTime">
            <el-date-picker
              type="datetime"
              placeholder="选择日期"
              style="width: 100%"
              v-model="rule.payTime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </template>
      </template>
      <template
        v-if="rule.use_status === 'official' || rule.use_status === 'probation'"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="开始时间" prop="startTime">
              <el-date-picker
                type="datetime"
                placeholder="选择日期"
                style="width: 100%"
                v-model="rule.startTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结束时间" prop="endTime">
              <el-date-picker
                type="datetime"
                placeholder="选择日期"
                style="width: 100%"
                v-model="rule.endTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template v-if="rule.use_status !== 'test'">
        <div class="title-wrapper" style="margin-bottom: 12px">
          <div class="title">配送信息</div>
          <el-button 
            type="text" 
            icon="el-icon-setting" 
            @click="goToAddressBook"
            style="margin-left: 10px"
          >
            地址薄管理
          </el-button>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="收货人姓名" prop="recipientName">
              <el-autocomplete
                v-model="rule.recipientName"
                :fetch-suggestions="queryAddressBook"
                placeholder="请输入收货人姓名或搜索地址薄"
                style="width: 100%"
                clearable
                @select="handleSelectAddressBook"
                @clear="handleClearAddressBook"
                value-key="contactName"
                :debounce="200"
                :highlight-first-item="true"
                :trigger-on-focus="false"
                :select-when-unmatched="false"
                :popper-class="'address-book-dropdown'"
                :hide-loading="false"
                :loading="isSearching"
              >
                <template slot-scope="{ item }">
                  <div class="address-book-item">
                    <div class="item-name">
                      <i class="el-icon-user"></i>
                      {{ item.contactName }}
                    </div>
                    <div class="item-detail">
                      <i class="el-icon-phone"></i>
                      {{ item.mobile }}
                      <span v-if="item.companyName" class="company-info">
                        | <i class="el-icon-office-building"></i>
                        {{ item.companyName }}
                      </span>
                    </div>
                    <div v-if="item.province || item.city || item.district" class="item-address">
                      <i class="el-icon-location"></i>
                      {{ formatAddressPreview(item) }}
                    </div>
                  </div>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="收件人电话" prop="recipientPhone">
              <el-input
                v-model="rule.recipientPhone"
                placeholder="请输入"
                type="tel"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="收货地址" prop="recipientNote">
          <el-input
            v-model="rule.recipientNote"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="配送方式">
          <el-radio-group v-model="rule.delivery" @change="onDispatch">
            <el-radio label="0">第三方快递</el-radio>
            <el-radio label="1">自提</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="rule.delivery === '0'">
          <el-row>
            <el-col :span="8">
              <el-form-item label="快递公司" prop="deliveryWay">
                <el-input
                  v-model="rule.deliveryWay"
                  placeholder="请输入"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item label="快递单号" prop="deliveryCode">
                <el-input
                  v-model="rule.deliveryCode"
                  placeholder="请输入"
                ></el-input> </el-form-item
            ></el-col>
            <el-col :span="8">
              <el-form-item label="快递截图" prop="deliveryUrl">
                <input
                  type="file"
                  name="file"
                  @change="getDeliveryUrl($event)"
                /> </el-form-item
            ></el-col>
          </el-row>
        </template>
        <template v-if="rule.delivery === '1'">
          <el-row>
            <el-col :span="8">
              <el-form-item label="姓名" prop="personalName">
                <el-input
                  v-model="rule.personalName"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="收件人电话" prop="personalPhone">
                <el-input
                  v-model="rule.personalPhone"
                  placeholder="请输入"
                  type="tel"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注" prop="personalNote">
                <el-input
                  v-model="rule.personalNote"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </template>
      <el-form-item>
        <el-button type="primary" @click="submit('rule')">提交</el-button>
        <el-button @click="block">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import IndividualCustomers from "../../customer/individualCustomers.vue";

export default {
  data() {
    return {
      name: "add",
      url: this.getEnv(),
      rule: {
        institution: "0",
        device: "0",
        ins_id: "",
        file: [],
        payState: "0",
        delivery: "0",
        user_id: "",
        use_status: "official",
      },
      rules: {
        file: { required: true, message: "请上传文件" },
        ins_id: { required: true, message: "请选择机构名称" },
        dev_id: { required: true, message: "请输入设备号" },
        use_status: { required: true, message: "请选择服务状态" },
        inJoin: { required: true, message: "请选择关联场景" },
        crm: { required: true, message: "请输入CRM订单号" },
        pay: { required: true, message: "请选中" },
        payTime: { required: true, message: "请输入预期付款时间" },
        startTime: { required: true, message: "请选择开始时间" },
        endTime: { required: true, message: "请选择结束时间" },
        user_id: { required: true, message: "请选择用户信息" },
        recipientName: { required: true, message: "请输入收货人姓名" },
        recipientPhone: { required: true, message: "请输入收货人电话" },
        recipientNote: { required: true, message: "请输入收货地址" },
        delivery: { required: true, message: "请选择配送方式" },
      },
      selectList: [],
      selectList2: [],
      phoneList: [],
      searchTimer: null, // 地址簿搜索防抖定时器
      isSearching: false, // 搜索状态
    };
  },
  async created() {
    this.$http.post("/manage/institution/listAll").then((data) => {
      this.selectList = data["data"]["data"];
    });
    this.$http.get("/manage/rom-model/list").then((data) => {
      this.selectList2 = data["data"]["data"];
    });
    // this.$http.get("/manage/rom-model/list").then((data) => {
    //   this.phoneList = data["data"]["data"];
    // });
  },
  methods: {
    onDispatch() {
      if (this.rule.delivery === "1") {
        this.rule.deliveryWay = "";
        this.rule.deliveryCode = "";
        this.rule.deliveryUrl = "";
      } else {
        this.rule.personalName = "";
        this.rule.personalPhone = "";
        this.rule.personalNote = "";
      }
      this.$nextTick(() => {
        const formRef = this.$refs["rule"];
        if (formRef) {
          formRef.clearValidate(); // 或针对具体表单项调用 resetField()
        } else {
          console.warn("表单引用 'rule' 未找到");
        }
      });
    },
    onPay() {
      if (this.rule.device === "0") {
        this.rule.payTime = "";
      }
      this.$nextTick(() => {
        this.$refs["rule"].clearValidate();
      });
    },
    onSwitchDevice() {
      if (this.rule.device === "1") {
        this.rule.dev_id = "";
      } else {
        this.rule.file = "";
      }
      this.$nextTick(() => {
        this.$refs["rule"].clearValidate();
      });
    },
    onSwitch() {
      if (this.rule.institution === "1") {
        this.rule.ins_id = "";
      } else {
        this.rule.user_id = "";
      }
      this.$nextTick(() => {
        this.$refs["rule"].clearValidate();
      });
    },
    handleUserChange(props) {
      this.rule.user_id = props.id;
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return (
          document.location.protocol +
          "//" +
          "test.baitengfa.com/manage/dev/download/template"
        );
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return (
          document.location.protocol +
          "//" +
          "dev.iotmanage.baitengfa.com/manage/dev/download/template"
        );
      } else if (location.host == "iotmanage.baitengfa.com") {
        return (
          document.location.protocol +
          "//" +
          "iotmanage.baitengfa.com/manage/dev/download/template"
        );
      }
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.rule, "this.rule");
          const testStatus = this.rule.use_status === "test";
          const probationStatus = this.rule.use_status === "probation"
          if (this.rule.device === "0") {
            if(testStatus) {
              this.rule.payState = "";
              this.rule.payTime = "";
              this.rule.crm ="";
              this.rule.startTime = "";
              this.rule.endTime ="";
              this.rule.recipientName ="";
              this.rule.recipientNote = "";
              this.rule.recipientPhone ="";
              this.rule.personalName ="";
              this.rule.personalPhone = "";
              this.rule.personalNote ="";
              this.rule.deliveryUrl ="";
              this.rule.deliveryWay ="";
              this.rule.deliveryCode ="";
            }
            if(probationStatus) {
              this.rule.payState = "";
              this.rule.payTime = "";
              this.rule.crm ="";
            }
            this.$http
              .post("/manage/outBill/outOneStock", this.rule)
              .then((rs) => {
                if (rs.data.code == 0) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.$router.push("/inventory/batch/index");
                } else {
                  this.rule.file = "";
                  this.$message({
                    message: rs.data.message,
                    type: "error",
                  });
                }
              });
          }
          if (this.rule.device === "1") {
            let headers = {
              "Content-Type": "multipart/form-data",
            };
            let formData = new FormData();
            if (this.rule.file && this.rule.device === "1") {
              formData.append("file", this.rule.file);
            }
            if (this.rule.device === "0") {
              formData.append("devId", this.rule.dev_id);
            }
            if (this.rule.deliveryUrl) {
              const val = testStatus ? "" : this.rule.deliveryUrl;
              formData.append("deliveryUrl", this.rule.deliveryUrl);
            }

            if (this.rule.institution == "0") {
              formData.append("userType", 0);
              this.rule.ins_id && formData.append("insId", this.rule.ins_id);
            } else {
              formData.append("userType", 1);
              this.rule.user_id && formData.append("userId", this.rule.user_id);
            }

            if (this.rule.use_status) {
              formData.append("useStatus", this.rule.use_status);
            }
            if (this.rule.crm) {
              const val = this.rule.use_status !== "official" ? "" : this.rule.crm;
              formData.append("crm", val);
            }
            if (this.rule.payState) {
              const val = this.rule.use_status !== "official" ? "" : this.rule.payState;
              formData.append("payState", val);
            }
            if (this.rule.startTime) {
              const val = testStatus ? "" : this.rule.startTime;
              formData.append("startTime", val);
            }
            if (this.rule.endTime) {
              const val = testStatus ? "" : this.rule.endTime;
              formData.append("endTime", val);
            }
            if (this.rule.inJoin) {
              formData.append("inJoin", this.rule.inJoin);
            }
            if (this.rule.payTime) {
              const val = this.rule.use_status !== "official" ? "" : this.rule.payTime;
              formData.append("payTime", val);
            }
            if (this.rule.recipientName) {
              const val = testStatus ? "" : this.rule.recipientName;
              formData.append("recipientName", val);
            }
            if (this.rule.recipientNote) {
              const val = testStatus ? "" : this.rule.recipientNote;
              formData.append("recipientNote", val);
            }
            if (this.rule.recipientPhone) {
              const val = testStatus ? "" : this.rule.recipientPhone;
              formData.append("recipientPhone", val);
            }
            if (this.rule.personalName) {
              const val = testStatus ? "" : this.rule.personalName;
              formData.append("personalName", val);
            }
            if (this.rule.personalNote) {
              const val = testStatus ? "" : this.rule.personalNote;
              formData.append("personalNote", val);
            }
            if (this.rule.personalPhone) {
              const val = testStatus ? "" : this.rule.personalPhone;
              formData.append("personalPhone", val);
            }
            if (this.rule.deliveryWay) {
              const val = testStatus ? "" : this.rule.deliveryWay;
              formData.append("deliveryWay", val);
            }
            if (this.rule.deliveryCode) {
              const val = testStatus ? "" : this.rule.deliveryCode;
              formData.append("deliveryCode", val);
            }
            this.$http
              .post("/manage/outBill/outStock", formData, { headers: headers })
              .then((rs) => {
                if (rs.data.code == 0) {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.$router.push("/inventory/batch/index");
                } else {
                  this.rule.file = "";
                  this.$message({
                    message: rs.data.message,
                    type: "error",
                  });
                }
              });
          }
        }
      });
    },

    block() {
      this.$router.push("/inventory/batch/index");
    },
    getDeliveryUrl(event) {
      var file = event.target.files;
      for (var i = 0; i < file.length; i++) {
        //    上传类型判断
        var imgName = file[i].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          let headers = {
            "Content-Type": "multipart/form-data",
          };
          let formData = new FormData();
          if (file[i]) {
            formData.append("file", file[i]);
          }
          this.$http
            .post("/manage/file/upload", formData, { headers: headers })
            .then((rs) => {
              if (rs.data.code == 0) {
                this.rule.deliveryUrl = rs.data.message;
              }
            });
        }
      }
    },
    getFile(event) {
      var file = event.target.files;
      for (var i = 0; i < file.length; i++) {
        //    上传类型判断
        var imgName = file[i].name;
        var idx = imgName.lastIndexOf(".");
        if (idx != -1) {
          var ext = imgName.substr(idx + 1).toUpperCase();
          ext = ext.toLowerCase();
          console.log(file, "file");
          this.rule.file = file[i];
        }
      }
    },
    // 跳转到地址薄管理页面
    goToAddressBook() {
      this.$router.push("/inventory/batch/addressBook");
    },
    // 查询地址薄（用于自动完成）
    queryAddressBook(queryString, cb) {
      console.log('开始搜索:', queryString); // 调试信息
      
      if (!queryString || queryString.trim().length < 1) {
        console.log('搜索字符串为空，返回空结果');
        this.isSearching = false;
        cb([]);
        return;
      }
      
      // 清除之前的定时器
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      
      // 设置搜索状态
      this.isSearching = true;
      
      // 立即显示加载状态
      cb([]);
      
      // 防抖处理，避免频繁请求
      this.searchTimer = setTimeout(() => {
        console.log('执行搜索请求:', queryString.trim());
        
        // 调用地址薄接口进行搜索，支持按姓名、手机号、公司名称搜索
        const params = {
          pageNum: 1,
          pageSize: 20, // 增加搜索结果数量
          contactName: queryString.trim(),
        };
        
        console.log('搜索地址簿参数:', params); // 调试信息
        
        this.$http
          .post("/manage/outBillAddress/page", params)
          .then((res) => {
            console.log('地址簿搜索结果:', res.data); // 调试信息
            if (res.data.code === 0) {
              const results = res.data.data.records || [];
              console.log('处理前的搜索结果:', results); // 调试信息
              
              // 对结果进行排序，优先显示姓名匹配的结果
              const sortedResults = results.sort((a, b) => {
                const queryLower = queryString.toLowerCase();
                const aMatch = a.contactName && a.contactName.toLowerCase().includes(queryLower);
                const bMatch = b.contactName && b.contactName.toLowerCase().includes(queryLower);
                if (aMatch && !bMatch) return -1;
                if (!aMatch && bMatch) return 1;
                return 0;
              });
              
              console.log('处理后的搜索结果:', sortedResults); // 调试信息
              cb(sortedResults);
            } else {
              console.warn('地址簿搜索失败:', res.data.message);
              cb([]);
            }
          })
          .catch((error) => {
            console.error('地址簿搜索错误:', error);
            cb([]);
          })
          .finally(() => {
            // 清除定时器引用和搜索状态
            this.searchTimer = null;
            this.isSearching = false;
          });
      }, 100); // 减少防抖延迟到200ms，提升响应速度
    },
    // 选择地址薄项目后自动填充
    handleSelectAddressBook(item) {
      console.log('选择地址簿项目:', item); // 调试信息
      
      if (item && typeof item === 'object') {
        // 使用 $nextTick 确保数据更新后再进行其他操作
        this.$nextTick(() => {
          // 回填基本信息，使用更安全的方式
          this.rule.recipientName = item.contactName || item.name || "";
          this.rule.recipientPhone = item.mobile || item.phone || "";
          
          // 拼接完整地址，确保所有地址组件都存在
          const addressParts = [];
          if (item.province) addressParts.push(item.province);
          if (item.city) addressParts.push(item.city);
          if (item.district) addressParts.push(item.district);
          if (item.addressDetail) addressParts.push(item.addressDetail);
          if (item.address) addressParts.push(item.address); // 备用字段
          
          this.rule.recipientNote = addressParts.join(" ");
          
          console.log('回填后的数据:', {
            recipientName: this.rule.recipientName,
            recipientPhone: this.rule.recipientPhone,
            recipientNote: this.rule.recipientNote,
            originalItem: item
          }); // 调试信息
          
          // 强制更新视图
          this.$forceUpdate();
          
          // 显示成功提示
          this.$message({
            message: `地址信息已自动填充: ${this.rule.recipientName}`,
            type: "success",
            duration: 2000,
          });
          
          // 清除表单验证错误
          this.$nextTick(() => {
            if (this.$refs.rule) {
              this.$refs.rule.clearValidate(['recipientName', 'recipientPhone', 'recipientNote']);
            }
          });
        });
      } else {
        console.warn('选择的地址簿项目为空或格式不正确:', item);
        this.$message({
          message: "选择的地址信息格式不正确",
          type: "warning",
          duration: 2000,
        });
      }
    },
    // 清除收货人姓名时清空相关字段
    handleClearAddressBook() {
      this.rule.recipientName = "";
      this.rule.recipientPhone = "";
      this.rule.recipientNote = "";
      
      // 清除搜索定时器和状态
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
        this.searchTimer = null;
      }
      this.isSearching = false;
      
      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.rule) {
          this.$refs.rule.clearValidate(['recipientName', 'recipientPhone', 'recipientNote']);
        }
      });
    },
    // 格式化地址预览（用于下拉列表显示）
    formatAddressPreview(item) {
      const parts = [];
      if (item.province) parts.push(item.province);
      if (item.city) parts.push(item.city);
      if (item.district) parts.push(item.district);
      return parts.join(" ") || "地址信息";
    },
  },
  beforeDestroy() {
    // 组件销毁前清理定时器和状态
    if (this.searchTimer) {
      clearTimeout(this.searchTimer);
      this.searchTimer = null;
    }
    this.isSearching = false;
  },
  components: { IndividualCustomers },
};
</script>
<style scoped>
.tab {
  margin-bottom: 20px;
  margin-left: 100px;
  margin-top: 50px;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: start;
}

.title-wrapper {
  display: flex;
  align-items: center;
  background-color: #f1f1f1;
  width: 100%;
  padding-right: 10px;
}

.title {
  font-weight: 500;
  background-color: #f1f1f1;
  width: 100%;
  line-height: 30px;
  flex: 1;
}

/* 地址薄自动完成下拉样式 */
.address-book-item {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.address-book-item:last-child {
  border-bottom: none;
}

.address-book-item .item-name {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}

.address-book-item .item-name i {
  margin-right: 6px;
  color: #409EFF;
}

.address-book-item .item-detail {
  font-size: 12px;
  color: #606266;
  margin-bottom: 3px;
  display: flex;
  align-items: center;
}

.address-book-item .item-detail i {
  margin-right: 4px;
  color: #67C23A;
}

.address-book-item .company-info {
  margin-left: 8px;
  color: #909399;
}

.address-book-item .company-info i {
  margin-right: 4px;
  color: #E6A23C;
}

.address-book-item .item-address {
  font-size: 11px;
  color: #909399;
  display: flex;
  align-items: center;
}

.address-book-item .item-address i {
  margin-right: 4px;
  color: #F56C6C;
}

/* 地址簿下拉列表样式 */
.address-book-dropdown {
  max-height: 300px !important;
  overflow-y: auto !important;
}

.address-book-dropdown .el-autocomplete-suggestion__list {
  padding: 0 !important;
}

.address-book-dropdown .el-autocomplete-suggestion__item {
  padding: 0 !important;
  border-bottom: 1px solid #f0f0f0;
}

.address-book-dropdown .el-autocomplete-suggestion__item:last-child {
  border-bottom: none;
}

.address-book-dropdown .el-autocomplete-suggestion__item:hover {
  background-color: #f5f7fa !important;
}
</style>
